import { css } from 'emotion'

export const displayNoneStyles = css`
  display: none;
`
